import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../api-services/AdminHRService/Login/auth.service';
import { PermissionService } from '../../api-services/Permission/permission.service';
import { StorageService } from '../../guards/StorageService';

declare const KTComponents: any;
declare const KTMenu: any;

@Component({
  selector: 'app-sow-sidebar',
  standalone: false,
  templateUrl: './sow-sidebar.component.html',
  styleUrl: './sow-sidebar.component.css'
})
export class SowSidebarComponent  implements AfterViewInit {
  sidebarMenu: any = {};
  EmployeeName : any;
  DesignationName : any;
  profileUrl: string = '';

  constructor(
    private router: Router,
    public storageService: StorageService,
    private readonly permissionService: PermissionService,
    private readonly authService : AuthService
  ) { }

  ngOnInit(): void {
    this.permissionService.restore();
    this.sidebarMenu = this.permissionService.getSidebarStructure();
    this.EmployeeName = this.authService.getUser()?.employeeName;
    this.DesignationName = this.authService.getUser()?.designation;
    this.profileUrl = this.permissionService.getProfileUrl(this.router.url);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (typeof KTMenu !== 'undefined') {
        KTMenu.createInstances();
      }

      if (typeof KTComponents !== 'undefined') {
        KTComponents.init();
      }
    }, 100);
  }

   btnSignOut() {
    this.authService.logout();
    this.permissionService.clear();
    this.storageService.clearAll();
    this.router.navigateByUrl('/SignIn');
  }
}
